import { ECommercialOriginType } from "../../Enum/ECommercialOriginType"

export class SubscriptionCommercialOrigin {
  originType: ECommercialOriginType

  commercialReferralCode?: string

  constructor(data: Partial<SubscriptionCommercialOrigin> = {}) {
    this.originType = data.originType ?? ECommercialOriginType.Undefined

    this.commercialReferralCode = data.commercialReferralCode
  }
}
